import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";

const AutoScrolling = () => {
  const swiperRef = useRef();
  const logos = [
    "baemin",
    "daejeonBestOrthopaedics",
    "gamachi",
    "iamDonut",
    "ilovespine",
    "photoism",
    "sintanjinHanil",
    "ssDonkatsu",
    "sunmedica",
    "tomato",
    "wonderplace",
    "quadcoffee",
    "highorder",
    "hansot",
    "torder",
    "momsHandKalguksu",
    "appleFood",
    //
    "baemin",
    "daejeonBestOrthopaedics",
    "gamachi",
    "iamDonut",
    "ilovespine",
    "photoism",
    "sintanjinHanil",
    "ssDonkatsu",
    "sunmedica",
    "tomato",
    "wonderplace",
    "quadcoffee",
    "highorder",
    "hansot",
    "torder",
    "momsHandKalguksu",
    "appleFood",
  ];

  const rotatedLogos = Array(4)
    .fill()
    .map((_, i) =>
      logos.map((_, j) => logos[(j + Math.floor((logos.length / 8) * i)) % logos.length]),
    );

  return (
    <div className="autoScrolling">
      <div className="info">
        <strong>수많은 협력사와</strong>
        <span>맺어진 약속</span>
      </div>
      <Swiper
        ref={swiperRef}
        slidesPerView={"auto"}
        modules={[Autoplay]}
        loop
        observer={true}
        observeParents={true}
        autoplay={{ delay: 0, disableOnInteraction: false }}
        speed={5000}
        spaceBetween={20}>
        {logos.map((item, index) => (
          <SwiperSlide key={index} style={{ width: "fit-content" }}>
            <div className="slideContent">
              {rotatedLogos.map((arr, i) => (
                <img key={i} className="item" src={`/img/shopTheme/sm/${arr[index]}.png`} />
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default AutoScrolling;
